import React from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { ColumnsType } from 'antd/lib/table';

import configuration from 'services/rest/config';
import { getToken } from 'utils/axios-request';
import { ClientOffice } from 'interfaces';
import { Alert } from 'utils';

const tableColumns: ColumnsType<ClientOffice> = [
  {
    title: 'Nombre',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Manager',
    dataIndex: 'manager',
    key: 'manager',
  },
  {
    title: 'Activo',
    dataIndex: 'active',
    key: 'active',
    render(value: boolean) {
      return value ? 'Si' : 'No';
    },
  },
];

export const getClientOffices = (client: string) =>
  axios
    .get<ClientOffice[]>(`${configuration.miniServerURL}/offices`, {
      params: { client },
      headers: { ...getToken() },
    })
    .then((resp) => resp.data);

const useBranchOffices = () => {
  const { id = '' } = useParams();

  const [isLoading, setIsLoading] = React.useState(true);
  const [branchOffices, setBranchOffices] = React.useState<ClientOffice[]>([]);

  const fetchBranchOffices = React.useCallback(async () => {
    try {
      const resp = await getClientOffices(id);
      setBranchOffices(resp);
    } catch (err: any) {
      Alert.error(err, 'Error al obtener ClientOffices');
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  React.useEffect(() => {
    fetchBranchOffices();
  }, [fetchBranchOffices]);

  return {
    state: {
      isLoading,
      tableColumns,
      branchOffices,
      tablePagination: { hideOnSinglePage: true },
    },
  };
};

export default useBranchOffices;
